import PreviewElement from '../PreviewElement';

export default class TextElement extends PreviewElement {
  injectSessionData(page): void {
    // check if the area already exists
    let areaExist = page.areas.find((area) => {
      return area.name === this.element.content.areaTypeName;
    });

    // if it exists then update the text otherwise add a new area
    if (areaExist) {
      areaExist.text = this.element.content.content.text;
    } else {
      page.areas.push({
        name: this.element.content.areaTypeName,
        text: this.element.content.content.text
      });
    }
  }
}
